import { createContext, useContext } from "react";

import { DiscountUnitType } from "@intelligems/ig-types";

interface ProgressBarContextType {
  unitType: DiscountUnitType;
  mode: "toggle" | "input";
  cartValue: number;
  setCartValue: (cartValue: number) => void;
  aboveThreshold: boolean;
  setAboveThreshold: (aboveThreshold: boolean) => void;
}

export const ProgressBarContext = createContext<ProgressBarContextType>(
  undefined as unknown as ProgressBarContextType
);

export const useProgressBarContext = () => useContext(ProgressBarContext);
